var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap",style:(_vm.finallyStyle+_vm.shapeStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }